import { message } from "antd";
import { useScrollTo } from "hooks/useScrollTo";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useHashScroll(attrCards: any[] | null) {
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const navigate = useNavigate();
  const { scrollTo } = useScrollTo();

  useEffect(() => {
    if (!attrCards) return;

    const hash = location.hash;

    if (!hash) return;

    // Ссылка на комментарий кодируется как "{cardId}~comment-{id}" — сама
    // карточка находится по cardId, к комментарию внутри неё прокручивает
    // отдельный эффект в CommentList после того, как модалка откроется.
    const anchorId = hash.replace(/^#/, "").split("~")[0];

    if (!anchorId) return;

    // проверяем асинхронно, потому что данные
    // подгружаются асинхронно. scrollTo сам ждёт до ~2с и сообщает через
    // onNotFound, только если элемент так и не появился — раньше
    scrollTo(anchorId, () => {
      messageApi.error(
        "Карточка по ссылке не найдена. Возможно, она была скрыта или удалена автором или модератором",
      );
      navigate(
        { pathname: location.pathname, search: location.search, hash: "" },
        { replace: true },
      );
    });
  }, [location, attrCards]);

  return contextHolder;
}
